import { containsQuery } from "helpers/reqparams";
import { request } from "services/request";

const resource = "api/mechanics";

const getByPhoneNumber = (params: { phoneNumber: string }) =>
    request(`${resource}/getByPhoneNumber?phoneNumber=${encodeURIComponent(params.phoneNumber)}`, { method: "GET" });

const list = (params: {}) => request(`${resource}/getList${containsQuery(params)}`, { method: "GET" });

export { getByPhoneNumber, list };
